import React, { useState } from 'react';
import { Select } from '@fabric-ui/components';
import { isJSON } from '@utils/utils';
import { TokenSuggestion } from './types';

const TokenFilterInput = ({
  value,
  onChange,
  onTokenSelect,
  tokenSuggestions,
  placeholder,
  disabled,
  readOnly,
  error,
  inputWidth,
}: {
  value: any;
  onChange: (value: string) => void;
  onTokenSelect?: (token: TokenSuggestion) => void;
  tokenSuggestions: TokenSuggestion[];
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  error?: any;
  inputWidth?: number | string;
}) => {
  const [tokenPopperOpen, setTokenPopperOpen] = useState(false);

  const handleTokenChange = (v: string) => {
    const hasMatches = !!tokenSuggestions.some(t => t.value.startsWith(v));
    setTokenPopperOpen(v.startsWith('{') && hasMatches);
    onChange(v);
  };

  const handleTokenSelect = (token: TokenSuggestion | null) => {
    setTokenPopperOpen(false);
    if (token) onTokenSelect?.(token);
  };

  const isSelectedToken = tokenSuggestions.some(t => t.value === value);
  const isTypingToken = typeof value === 'string' && value.startsWith('{') && !isSelectedToken;

  return (
    <Select
      size="small"
      style={{
        width: inputWidth,
        ...(isSelectedToken && { input: { color: 'var(--color-content-interactive-primary-default)', fontWeight: 500 } }),
      }}
      freeSolo
      options={isTypingToken ? tokenSuggestions.map(t => ({ title: t.title, value: t.value })) : []}
      value={value ?? ''}
      getLabelFunc={v => (typeof v === 'object' ? v?.title : v) ?? ''}
      getValueFunc={v => (typeof v === 'object' ? v?.value : v) ?? ''}
      onChange={selected => {
        const token = tokenSuggestions.find(t => t.value === selected);
        if (token) handleTokenSelect(token);
        else if (!selected) {
          setTokenPopperOpen(false);
          onChange('');
        }
      }}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      error={error}
      selectIcon={<span />}
      muiProps={
        {
          disableClearable: true,
          forcePopupIcon: false,
          open: tokenPopperOpen,
          onOpen: () => {},
          inputValue: isJSON(value) ? '' : (value ?? ''),
          onInputChange: (_: any, v: string, reason: string) => {
            if (reason === 'input') handleTokenChange(v);
            if (reason === 'clear') {
              setTokenPopperOpen(false);
              onChange('');
            }
          },
          onClose: (_, reason) => {
            if (reason !== 'selectOption') setTokenPopperOpen(false);
          },
          filterOptions: (opts, { inputValue }) => opts.filter(o => o.value.startsWith(inputValue)),
        } as any
      }
    />
  );
};

export default TokenFilterInput;
